
import Vue from "vue";
import AppProductsTableInfo from "./SaleInfoTable.vue";
import AppTotals from "@/components/products-table/Totals.vue";
import { Sale } from "@/models/base";
import {DossierConfigService, UserConfigService} from "@/services";
import {IClientStats} from "@/utils/client-stats";
import AppContactInfoModal from "@/components/contacts/ContactInfoModal.vue";
import { printHumanFloat } from "@/utils/pretty-print";

export default Vue.extend({
	data(){
		return {
			contactInfoModal: false,
			clientStats: {} as IClientStats,
			hoverCardStyle: {top: "0px", left: "0px"} as {top:string, left:string},
			showHoverCard: false,
			hideHoverCardTimer: null as null | ReturnType<typeof setTimeout>
		};
	},
	props: {
		sale: {
			type: Object as () => Sale,
			required: true
		}
	},
	computed: {
		moreText():string {
			if (!this.sale.Contact || !this.sale.Contact.MainAddress) return "";
			if (this.sale.Contact.MainAddress.AddressLine1 && this.sale.Contact.MainAddress.PostalAndCity) {
				return `${this.sale.Contact.MainAddress.AddressLine1}, ${this.sale.Contact.MainAddress.PostalAndCity}` + " | ";
			}
			return `${this.sale.Contact.MainAddress.AddressLine1}${this.sale.Contact.MainAddress.PostalAndCity}` + " | ";
		},
		profitVisible():boolean {
			return UserConfigService.getSaleSettings().ShowProfitBar;
		},
		displayExtraFields(): any {
			let d = DossierConfigService.getExtraFieldNamesConfigs().getContactNamesByGroupID(1);
			return d ? true : false;
		},
		hoverAddressLines(): string[] {
			let address = this.sale.Contact && this.sale.Contact.MainAddress;
			if (!address) return [];
			let lines:string[] = [];
			if (address.AddressLine1) lines.push(address.AddressLine1);
			if (address.AddressLine2) lines.push(address.AddressLine2);
			let postalCity = address.PostalAndCity || [address.Postal, address.City].filter(v=>v).join(" ");
			if (postalCity) lines.push(postalCity);
			if (address.CountryName && address.CountryCode != "BE") lines.push(address.CountryName);
			return lines;
		},
		hoverEmail(): string {
			if (!this.sale.Contact || !this.sale.Contact.MainAddress) return "";
			return this.sale.Contact.MainAddress.getDefaultEmail();
		},
	},
	methods: {
		humanFloat(val:number){
			return printHumanFloat(val);
		},
		onContactEnter(e: MouseEvent) {
			let el = e.currentTarget as HTMLElement;
			if (el) {
				let box = el.getBoundingClientRect();
				this.hoverCardStyle = {top: `${box.bottom}px`, left: `${box.left}px`};
			}
			this.clearHideHoverCard();
			this.showHoverCard = true;
		},
		clearHideHoverCard() {
			if (this.hideHoverCardTimer) {
				clearTimeout(this.hideHoverCardTimer);
				this.hideHoverCardTimer = null;
			}
		},
		scheduleHideHoverCard() {
			this.clearHideHoverCard();
			this.hideHoverCardTimer = setTimeout(() => {
				this.showHoverCard = false;
			}, 150);
		}
	},
	destroyed(){
		this.clearHideHoverCard();
	},
	components: {
		AppProductsTableInfo,
		AppTotals,
		AppContactInfoModal
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
